import { useEffect, useLayoutEffect } from "react";

import { CAN_USE_DOM } from "./canUseDOM";

// https://github.com/facebook/lexical/blob/main/packages/shared/src/useLayoutEffect.ts
const useLayoutEffectImpl: typeof useLayoutEffect = CAN_USE_DOM ? useLayoutEffect : useEffect;

export default useLayoutEffectImpl;
